import {
  Button,
  TextField,
} from '@material-ui/core'
import { TagPicker } from 'rsuite'
import { actions, useDispatch } from '@/redux'
import { makeStyles } from '@material-ui/core/styles'
import { roles } from '@/libs/common'
import { useDialog } from '@/hooks/app'
import Dialog from '@/components/Dialog'
import React from 'react'
import * as _ from 'lodash'
const defaultState = {
  username: '',
  password: '',
  role: '',
}

export default function AddUserDialog (props) {
  const dispatch = useDispatch()
  const classes = useStyles(props)
  const { open } = useDialog('addUser')
  const [inputState, setInputState] = React.useState(defaultState)
  const [selectedRoles, setSelectedRoles] = React.useState([])
  const roleList = roles.map(role => {
    return {
      value: role.id,
      label: role.name,
    }
  })
  const handleClose = () => {
    dispatch(actions.app.toggleDialog('addUser'))
  }

  const handleChange = (event) => {
    const { name, value } = event.currentTarget
    setInputState({ ...inputState, [name]: value })
  }

  const handleSubmit = async () => {
    const param = {
      ...inputState,
      role: selectedRoles.join(','),
    }
    await dispatch(actions.app.toggleDialog('addUser'))
    await dispatch(actions.user.createUser(param)).catch(e => {
      const errorMessage = _.get(e, 'response.data.message') || e
      window.alert(errorMessage)
    })
    await dispatch(actions.user.getUsers())
  }

  const handleSelect = (e) => {
    e = e || []
    setSelectedRoles(e)
  }
  return (
    <Dialog
      title='Add New User'
      open={open}
      handleClose={handleClose}
      renderActions={() => {
        return (
          <Button
            variant='contained'
            color='primary'
            disableElevation
            onClick={handleSubmit}
          >
            Submit
          </Button>
        )
      }}
    >
      <div className={classes.box}>
        <div>Username:</div>
        <TextField
          variant='outlined'
          size='small'
          name='username'
          fullWidth
          classes={{ root: classes.textField }}
          value={inputState.username}
          onChange={handleChange}
        />
        <div>Password:</div>
        <TextField
          variant='outlined'
          size='small'
          name='password'
          fullWidth
          type='password'
          classes={{ root: classes.textField }}
          value={inputState.password}
          onChange={handleChange}
        />
        <div>Role:</div>
        <TagPicker
          className={classes.roleSelecter}
          onChange={handleSelect}
          value={selectedRoles}
          data={roleList}
          placeholder='Role'
        />
      </div>
    </Dialog>
  )
}

const useStyles = makeStyles((theme) => ({
  box: {
    display: 'grid',
    gridTemplateColumns: '1fr 3fr',
    columnGap: theme.spacing(3),
    rowGap: theme.spacing(1),
    padding: theme.spacing(3),
    alignItems: 'center',
  },
  roleSelecter: {
    minWidth: '100%',
    maxWidth: '300px',
  },
}))
